import React from 'react';
import { Card } from '../common';

/**
 * Insight Block Component
 * Display insights, recommendations, and key points
 */
const InsightBlock = ({ 
  title, 
  icon = '💡', 
  points = [], 
  type = 'info', // info, success, warning, tip
  className = '' 
}) => {
  const typeStyles = {
    info: {
      bg: 'bg-blue-500/10',
      border: 'border-blue-500/30',
      text: 'text-blue-300',
      iconBg: 'bg-blue-500/20'
    },
    success: {
      bg: 'bg-green-500/10',
      border: 'border-green-500/30',
      text: 'text-green-300',
      iconBg: 'bg-green-500/20'
    },
    warning: {
      bg: 'bg-yellow-500/10',
      border: 'border-yellow-500/30',
      text: 'text-yellow-300',
      iconBg: 'bg-yellow-500/20'
    },
    tip: {
      bg: 'bg-purple-500/10',
      border: 'border-purple-500/30',
      text: 'text-purple-300',
      iconBg: 'bg-purple-500/20'
    }
  };

  const style = typeStyles[type] || typeStyles.info;

  return (
    <div className={`${style.bg} border ${style.border} rounded-xl p-6 ${className}`}>
      <div className="flex items-start gap-4">
        <div className={`${style.iconBg} rounded-lg p-3 flex-shrink-0`}>
          <span className="text-3xl">{icon}</span>
        </div>
        
        <div className="flex-1">
          {title && (
            <h3 className={`text-xl font-bold ${style.text} mb-3`}>
              {title}
            </h3>
          )}
          
          {points.length > 0 && (
            <ul className="space-y-2">
              {points.map((point, index) => (
                <li key={index} className="flex items-start gap-2 text-slate-300">
                  <span className={`${style.text} mt-1 flex-shrink-0`}>•</span>
                  <span>{point}</span>
                </li>
              ))}
            </ul>
          )}
        </div>
      </div>
    </div>
  );
};

export default InsightBlock;
